import { Link } from "react-router-dom";
import { productConfig } from "../config/product";
import { getSelectableLanguages } from "../i18n/languages";
import { useSession } from "../state/SessionProvider";

/**
 * Neutral first screen.
 * Soft launch: six languages selectable when availability.softLaunch is set.
 * Optional QR suggested-mode is a dismissible choice — never trapping.
 */
export function HomePage() {
  const {
    languageCode,
    setLanguageCode,
    translate,
    qrContext,
    setQrContext,
  } = useSession();
  const selectable = getSelectableLanguages();
  const showLanguageSelector = selectable.length >= 2;
  const suggestHospitality = qrContext?.suggestedMode === "hospitality";

  function dismissSuggestion() {
    if (!qrContext) return;
    setQrContext({ ...qrContext, suggestedMode: null });
  }

  return (
    <section className="home stack" aria-labelledby="home-heading">
      <header className="home-hero">
        <h1 id="home-heading" className="home-title" tabIndex={-1}>
          {productConfig.displayName}
        </h1>
        <p className="home-tagline">{productConfig.shortDescription}</p>
      </header>

      {suggestHospitality ? (
        <div
          className="stack qr-suggest"
          role="region"
          aria-labelledby="qr-suggest-label"
        >
          <p id="qr-suggest-label">{translate("page.qr.suggest_hospitality")}</p>
          <Link className="mode-link mode-link--quiet" to="/pro/hospitality">
            {translate("page.qr.suggest_hospitality_cta")}
          </Link>
          <button
            type="button"
            className="text-action"
            onClick={dismissSuggestion}
          >
            {translate("page.qr.suggest_dismiss")}
          </button>
        </div>
      ) : null}

      {showLanguageSelector ? (
        <fieldset className="stack language-fieldset">
          <legend>{translate("entry.choose_language")}</legend>
          {selectable.map((lang) => (
            <label key={lang.code} className="choice">
              <input
                type="radio"
                name="language"
                value={lang.code}
                checked={languageCode === lang.code}
                onChange={() => setLanguageCode(lang.code)}
              />
              <span lang={lang.code}>{lang.nativeName}</span>
            </label>
          ))}
        </fieldset>
      ) : null}

      <div className="stack" aria-labelledby="mode-heading">
        <h2 id="mode-heading" className="mode-heading">
          {translate("entry.choose_mode")}
        </h2>

        <Link className="mode-card" to="/help">
          <span className="mode-card-label">{translate("mode.help.label")}</span>
          <span className="mode-card-blurb">{translate("mode.help.blurb")}</span>
        </Link>

        <Link className="mode-card" to="/concern">
          <span className="mode-card-label">
            {translate("mode.concern.label")}
          </span>
          <span className="mode-card-blurb">
            {translate("mode.concern.blurb")}
          </span>
        </Link>

        <Link className="mode-card" to="/pro/hospitality">
          <span className="mode-card-label">
            {translate("mode.hospitality.label")}
          </span>
          <span className="mode-card-blurb">
            {translate("mode.hospitality.blurb")}
          </span>
        </Link>
      </div>
    </section>
  );
}
